import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'

import { InicioService } from '../shared/services/inicio.service';
import { InformacionInicioDto } from '../shared/models/informacion-inicio-dto';
import { CargandoComponent } from '../cargando/cargando.component';
import { environment } from '../../environments/environment'
import {Router} from "@angular/router";

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {

  informacionInicialDto: InformacionInicioDto = new InformacionInicioDto();
  @ViewChild('cargandoModal') private cargandoModal: ElementRef;
  modalRef: NgbModalRef;

  constructor(private inicioService: InicioService,
  private modalService: NgbModal, private router: Router) { }

  ngOnInit() {
    this.informacionInicialDto.direccionIp = 'Direccion'
    this.cargarInformacionInicial();
  }

  public cargarInformacionInicial(): void{
    this.inicioService.informacionInicialPorIp().subscribe(
      resultado => {
        this.informacionInicialDto = resultado
        if(this.informacionInicialDto.sede == null){
          this.informacionInicialDto.sede = 'No Disponible'
        }
        if(this.informacionInicialDto.ciudad == null){
          this.informacionInicialDto.ciudad = 'No Disponible'
        }
      }
    )
  }

  public ingresar(): void{
    this.router.navigate(['solicitar-ip']);
  }


}



// WEBPACK FOOTER //
// ./src/app/inicio/inicio.component.ts